import { Section } from '../components/Section/Section'
import useURLParams from 'hooks/useURLParams'
import { useDemographics } from 'hooks/queries/useDemographics/useDemographics'
import { GenderDistribution } from '../GenderDistribution/GenderDistribution'
import { AgeGenderDistribution } from '../AgeGenderDistribution/AgeGenderDistribution'
import Styles from '../Analytics.module.scss'
import { useAnalyticsContext } from '../AnalyticsContext'

export const AudienceDemographics = () => {
  const [searchParams] = useURLParams()
  const integrationId = parseInt(searchParams.get('external_integration_id') as string)
  const { period } = useAnalyticsContext()
  const { data, isFetching } = useDemographics(integrationId, ['gender', 'age_gender'], period)

  return (
    <Section title="Demographics">
      <div className={Styles.metricsGroup}>
        <GenderDistribution data={data?.gender} isFetching={isFetching} />
        <AgeGenderDistribution data={data?.age_gender} isFetching={isFetching} />
      </div>
    </Section>
  )
}
